import { render, staticRenderFns } from "./JjTabHead.vue?vue&type=template&id=5fb714ab&scoped=true"
import script from "./JjTabHead.vue?vue&type=script&lang=js"
export * from "./JjTabHead.vue?vue&type=script&lang=js"
import style0 from "./JjTabHead.vue?vue&type=style&index=0&id=5fb714ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb714ab",
  null
  
)

export default component.exports